


























import { Vue, Component, Prop, PropSync } from 'vue-property-decorator'
import { EApprovalState, EApprovalType } from '@/typings/enum'

interface info {
    applicant: string,
    type: string,
    typeId: number,
    status: string,
    statusId: number
  }

@Component({
  name: 'ApprovalPopup',
  components: {
    'PopupAppInfo': () => import(/* webpackChunkName: "PopupAppInfo" */'./popup-app-info.vue'),
    'PopupAppUpdown': () => import(/* webpackChunkName: "PopupAppUpdown" */'./popup-app-updown.vue'),
    'appPermission': () => import(/* webpackChunkName: "appPermission" */'./popup-permission.vue')
  }
})
export default class extends Vue {
  @PropSync('visible', { default: false })
  isVisible!: boolean

  @Prop({ required: true })
  popupinfo!: info

  private EApprovalState = EApprovalState

  cancelDialog() {
    this.isVisible = false
  }
  confirmDialog() {
    this.isVisible = false
  }
}
